import React from 'react';

import Swiper from 'swiper';
import 'swiper/css/swiper.min.css';

class Banner extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            banners: ["yellow", "black", "dark-blue"]
        }
    }

    componentDidMount() {
        const {num} = this.props;
        const index = num ?? "";
        const slides = document.querySelectorAll(`.swiper-slide-ref${index}`);
        slides.forEach(slide => slide.classList.add('hidden'));
        slides[0].classList.add('visible');

        let currentIndex = 0;
        const totalSlides = slides.length;

        const showNext = () => {
            const currentSlide = slides[currentIndex];
            const nextIndex = (currentIndex + 1) % totalSlides;
            const nextSlide = slides[nextIndex];
            currentSlide.classList.remove('visible');
            setTimeout(() => {
                this.swiper.slideToLoop(nextIndex, 0, false);
                nextSlide.classList.add('visible');
                currentIndex = nextIndex;
            }, 10);
        };

        this.swiper = new Swiper(`.swiper-container-ref${index}`, {
            loop: true,
            allowTouchMove: false,
        });

        this.interval = setInterval(showNext, 20000);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    render() {
        const {num} = this.props;
        const {banners} = this.state;
        const index = num ?? "";

        return <div className={`swiper-container-ref${index} swiper-container`}>
            <div className="swiper-wrapper">
                {
                    banners.map((e, i) => {
                        return <div key={i} className={`swiper-slide-ref${index} swiper-slide hidden ${i === 0 && "visible"}`}>
                            <a href="/">
                                <img src={require(`../../../../assets/images/top-banner/${e}.gif`)} border="0"
                                     width="520" height="70" alt=""/>
                            </a>
                        </div>
                    })
                }
            </div>
        </div>
    }
}

export default Banner;
